<template>
  <UTooltip
    v-if="icon"
    :text="$t(`gender.${gender}`)"
  >
    <UIcon
      :name="icon"
      :class="iconClass"
    />
  </UTooltip>
</template>

<script setup lang="ts">
import { Gender } from "~/enums/gender";

const props = withDefaults(
  defineProps<{
    gender?: Gender | null;
    iconClass?: string;
  }>(),
  {
    gender: null,
    iconClass: "h-8 w-8 text-blue-dark",
  },
);

const icon = computed(() => {
  if (!props.gender) return undefined;

  return props.gender === Gender.Male
    ? "mdi-light:gender-male"
    : props.gender === Gender.Female
      ? "mdi-light:gender-female"
      : "mdi-light:gender-male-female";
});
</script>
